export default __webpack_public_path__ + "static/media/CV-IMG1.c04b0884.png";